t = require('views/internal/teacup-with-helpers')('select_emoji')

module.exports = ->
  t.li '.item', ->
    t.a '.name.js-select-emoji', { href: '#', title: t.mustacheVar('name') }, ->
      t.img '.emoji', { src: t.mustacheVar('image') }
      t.span '.emoji-name', { name: t.mustacheVar('name') }, ->
        t.text t.mustacheVar('name')



// WEBPACK FOOTER //
// ./app/scripts/views/templates/select_emoji.coffee